// removed by extract-text-webpack-plugin
module.exports = {"FlightListItem":"_3Wzx_","FlightListItemActive":"_36S-i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/InternationalTupleRoundTrip/InternationalTupleDetails/InternationalTupleInner/InternationalTupleInner.scss
// module id = 843
// module chunks = 0